/** Cours de référence BCE du 01.10.2026 : 1 EUR = 0,9437 CHF.
 * Les montants EUR sont des repères commerciaux ; la facture reste en CHF. */
export const CHF_PAR_EUR = 0.9437

export function estSiteInternational(hote = globalThis.location?.hostname ?? ''): boolean {
  return /^(?:www\.)?ridomio\.(?:fr|com)$/iu.test(hote)
}

export function estSiteRidomio(hote = globalThis.location?.hostname ?? ''): boolean {
  return /^(?:www\.)?ridomio\.(?:ch|fr|com)$/iu.test(hote)
}

/** Garde le même titre avant et après l'hydratation de la vitrine. */
export function titreOngletRidomio(hote = globalThis.location?.hostname ?? ''): string | null {
  if (/^(?:www\.)?ridomio\.ch$/iu.test(hote)) {
    return 'RidoMio | Billetterie et abonnements pour les salles suisses'
  }
  if (/^(?:www\.)?ridomio\.fr$/iu.test(hote)) {
    return 'RidoMio France | Billetterie et abonnements pour vos spectacles'
  }
  if (/^(?:www\.)?ridomio\.com$/iu.test(hote)) {
    return 'RidoMio | Billetterie et abonnements pour vos événements'
  }
  return null
}

export function estSiteFrancais(hote = globalThis.location?.hostname ?? ''): boolean {
  return /^(?:www\.)?ridomio\.fr$/iu.test(hote)
}

export function prixVitrine(chf: number, decimales = Number.isInteger(chf) ? 0 : 2): string {
  const international = estSiteInternational()
  const valeur = international ? chf / CHF_PAR_EUR : chf
  const [entier, fraction] = valeur.toFixed(decimales).split('.')
  const montant = (entier ?? '').replace(/\B(?=(\d{3})+(?!\d))/gu, '’')
    + (fraction === undefined ? (international ? '' : '.–') : `.${fraction}`)
  return `${international ? 'EUR' : 'CHF'} ${montant}`
}
